/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import { never } from '../util.type';
import EnvEnum from './env-enum';

// TODO Mohlo by se odstranit opakování napříč různými prostředími (multi-platformní kód).
// - /util.js parseEnv.
// - Budou asi hlavně problémy s importy.
/**
 * Utility pro práci s číselníkem prostředí.
 */
class EnvUtil {
  /**
   * Vygeneruje textovou reprezentaci prostředí.
   * @param {EnvEnum} value Prostředí z číselníku.
   * @returns {string | undefined} Prostředí jako text.
   */
  static generate(value) {
    switch (value) {
      case EnvEnum.DEV:
        return 'development';
      case EnvEnum.PROD:
        return 'production';
      default:
        never(value);
        return undefined;
    }
  }

  /**
   * Načte prostředí z textového řetězce.
   * @param {import('../util.type').LiteralUnion<'dev' | 'development' | 'prod' | 'production', string> | null | undefined} value Prostředí jako text.
   * @returns {EnvEnum | undefined} Prostředí z číselníku.
   */
  static parse(value) {
    const knownValue =
      /** @type {'dev' | 'development' | 'prod' | 'production'} */ (value);
    switch (knownValue) {
      case 'dev':
      case 'development':
        return EnvEnum.DEV;
      case 'prod':
      case 'production':
        return EnvEnum.PROD;
      default:
        never(knownValue);
    }
    return undefined;
  }
}

export default EnvUtil;
